// extracted by mini-css-extract-plugin
module.exports = {"blogPostCount":"blogPostCount-module--blogPostCount--3Y-1L"};